import { bl_ppl_ap_testbed_sending_doc_event_RowClass } from '../../../dbschema/bl_ppl_ap_testbed_sending_doc_event.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolAPTestbedSendingDocEventContainerModel extends BaseContainerModel {
    bl_ppl_ap_testbed_sending_doc_event: bl_ppl_ap_testbed_sending_doc_event_RowClass = new bl_ppl_ap_testbed_sending_doc_event_RowClass();
}